<template>
    <div class="spotlight-group">
        <div class="spotlight-group-header" @click="$emit('toggle')">
            <svg class="spotlight-group-chevron" :class="{ 'spotlight-group-chevron--collapsed': collapsed }" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
            <span class="spotlight-group-label">{{ groupLabel }}</span>
            <span class="spotlight-group-count">{{ group.items.length }}</span>
        </div>
        <div v-show="!collapsed" class="spotlight-group-items">
            <component
                v-for="(item, i) in group.items"
                :key="item.id || i"
                :is="resultComponent"
                :item="item"
                :focused="focusedGroup === group.key && focusedIndex === i"
                @select="$emit('select', { group: group.key, item: $event })"
            />
        </div>
    </div>
</template>

<script>
import { RESULT_REGISTRY } from './results/resultRegistry'

export default {
    name: 'SpotlightGroup',
    props: {
        group: { type: Object, required: true },
        collapsed: { type: Boolean, default: false },
        focusedIndex: { type: Number, default: -1 },
        focusedGroup: { type: String, default: null }
    },
    emits: ['toggle', 'select'],
    computed: {
        resultComponent() {
            return RESULT_REGISTRY[this.group.key] || null
        },
        groupLabel() {
            return this.$t('common.spotlight.groups.' + this.group.key) || this.group.label || this.group.key
        }
    }
}
</script>
